<template>
  <div class="parking-data">
    <div class="parking-data__description" v-html="descriptionTop"></div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, onMounted, Ref, ref,
} from 'vue';

const TemplateModalParkingSpot: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  name: 'TemplateModalParkingSpot',
  setup(props) {
    const descriptionTop: Ref<string> = ref('');

    onMounted(() => {
      const { metaData } = props.templateData;
    });

    return {
      descriptionTop,
    };
  },
});
export default TemplateModalParkingSpot;
</script>
